import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import './style.scss'

import { LOCALE_PREFIX } from './constants'
import Counter from '../../../../../../../../../../../components/Counter'

export default function Summary({ restrictions = 0, total = 0 }) {
    return (
        <div className={'estates-summary'}>
            <Counter
                twoValues
                leftValue={{
                    value: restrictions,
                }}
                rightValue={{
                    value: total,
                }}
                description={
                    <div className={'value-description'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.description`} values={{ br: <br /> }} />
                        <Tooltip
                            id={'estates-summary-tooltip'}
                            content={<FormattedMessage id={`${LOCALE_PREFIX}.tooltip`} />}
                            position={POSITION.BOTTOM}
                            align={ALIGN.CENTER}
                            width={'250px'}
                            automaticAlignChange
                        >
                            <div className={'help'} />
                        </Tooltip>
                    </div>
                }
            />
        </div>
    )
}

Summary.propTypes = {
    restrictions: PropTypes.number,
    total: PropTypes.number,
}
